import { type FacebookBasicCredentials } from '@unipile/provider-facebook';
import { Button, Field, FieldGroup, FieldLabel, Input, LocationConfig, Spinner, useHostedAuthSession } from '@unipile/ui';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export function CredentialsForm({
  onSubmit,
  isPending,
}: {
  onSubmit: (data: FacebookBasicCredentials) => void;
  isPending?: boolean;
}) {
  const { data: session } = useHostedAuthSession();
  const form = useForm<FacebookBasicCredentials>({
    defaultValues: {
      username: session?.config?.global?.login_hint || '',
      password: '',
    },
  });
  const { t } = useTranslation();

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} className="mt-4 space-y-4">
      <FieldGroup>
        <Controller
          control={form.control}
          name="username"
          rules={{ required: t('LoginScreen.form.username.required', { ns: 'facebook' }) }}
          render={({ field }) => (
            <Field>
              <FieldLabel>{t('LoginScreen.form.username.label', { ns: 'facebook' })}</FieldLabel>
              <Input placeholder={t('LoginScreen.form.username.placeholder', { ns: 'facebook' })} {...field} />
            </Field>
          )}
        />

        <Controller
          control={form.control}
          name="password"
          rules={{ required: t('LoginScreen.form.password.required', { ns: 'facebook' }) }}
          render={({ field }) => (
            <Field>
              <FieldLabel>{t('LoginScreen.form.password.label', { ns: 'facebook' })}</FieldLabel>
              <Input type="password" placeholder="••••••••" {...field} />
            </Field>
          )}
        />

        <LocationConfig provider="facebook" />

        <Button type="submit" disabled={isPending}>
          {isPending && <Spinner />}
          {t('Common.next')}
        </Button>
      </FieldGroup>
    </form>
  );
}
